import { Modal } from '@/components/subscription/lp/modal'
import { styles } from './styles.css'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'

type Props = {
  renderTrigger: () => React.ReactNode
}

export const NutrientModal: React.FC<Props> = ({ renderTrigger }) => {
  return (
    <Modal
      title="お花を楽しむすべての人に使ってほしいアイテム"
      renderTrigger={renderTrigger}
      renderContent={() => {
        return (
          <div className={styles.content}>
            <h2 className={styles.heading}>
              お花を楽しむすべての人に
              <br />
              使ってほしいアイテム
            </h2>
            <p className={styles.text}>
              お花が届いたら、必ず使ってほしい切り花の栄養剤。水換えのたびに使うことで、お花の持ちがぐんとよくなります。そこで今回栄養剤のパック（5個）を初回注文特典としてプレゼント！
            </p>
            <p className={styles.text}>
              お花の元気がなくなる理由のひとつが「水の汚れ」。茎の切り口からバクテリアが発生し、水が汚れてしまうことで茎先が腐り、水をうまく吸いあげられなくなってしまいます😢
            </p>
            <img src={image1} />
            <p className={styles.text}>
              この栄養剤はバクテリアの発生を防ぎ、水をきれいに保ちながらお花の水上がりをサポート。水換えの頻度も少なくてOK。水500mlに対して1袋が希釈の目安です。
            </p>
            <h2 className={styles.heading}>本当に効果ある？</h2>
            <img src={image2} />
            <p className={styles.text}>
              「本当に効果あるの？」「気休め程度？」「入れない方がむしろよいのでは？」そんな疑問にお答えするため、スタッフが実際に6日間検証してみました🧐栄養剤を混ぜた水（右）と水のみ（左）に同じ日に仕入れたバラを入れ、一度も水換えをせずに様子を見てみます。夏場で不在時は30℃を超えてしまうような過酷な環境ですが果たして...。
            </p>
            <img src={image3} />
            <p className={styles.text}>
              3日目あたりから水質に変化が👀6日目になるとその差は明らか（写真）。水の濁りはもちろん、栄養剤を入れなかった方のバラには傷みも見られます。
            </p>
            <p className={styles.text}>せっかくのかわいいお花、長持ちさせたいですよね。ぜひお試しください☺️</p>
            <p className={styles.text}>
              内容量：5g（500ml用）×5袋セット
              <br />
              成分：糖類、抗菌剤、有機酸
            </p>
          </div>
        )
      }}
    />
  )
}
